import './_ConfirmDeleteFeedModal.scss';
import { Modal, Button } from 'react-bootstrap';
import { IConfirmDeleteFeedModal } from '../types/IDataFeedModal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { litrals } from '../../../../../constants/Litrals';

const ConfirmDeleteFeedModal = (props: IConfirmDeleteFeedModal) => {
  return (
    <Modal
      contentClassName="modal-delete-feed"
      show={props.show}
      onHide={() => props.onClose()}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>
      </Modal.Header>
      {props.content && (
        <Modal.Body>
          {props.content.split('-')[0]} <b>‘{props.content.split('-')[1]}’</b>
          {props.content.split('-')[2]}
        </Modal.Body>
      )}
      <Modal.Footer className="footer-button-group">
        <Button
          className="button-wrapper card-button primary"
          onClick={() => props.onConfirm()}
        >
          <FontAwesomeIcon
            className="trash-icon"
            icon={faTrashCan as IconProp}
          ></FontAwesomeIcon>
          {litrals.removeFeed}
        </Button>
        <Button
          className="button-wrapper card-button outline-primary"
          onClick={() => props.onClose()}
        >
          {litrals.cancel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteFeedModal;
